module.exports = __webpack_public_path__ + "img/h_04.d4e760ae.jpg";